import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  useEffect(() => {
    const t = localStorage.getItem("wtk_token");
    if (!t) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("wtk_token"); setUser(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("wtk_token", data.access_token);
    setUser(data.user);
    setAuthOpen(false);
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("wtk_token", data.access_token);
    setUser(data.user);
    setAuthOpen(false);
  };
  const logout = () => { localStorage.removeItem("wtk_token"); setUser(false); };
  const openAuth = (mode = "login") => { setAuthMode(mode); setAuthOpen(true); };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, authOpen, setAuthOpen, authMode, setAuthMode, openAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
